import React, { Component } from "react";
import styled from "styled-components";
import LeftArrow from "src/img/left-arrow.png";
import RightArrow from "src/img/right-arrow.png";
import { ScreenSwitch } from "../forms/SelectColor";
import FilteredPngStack from "src/scenes/Customise/components/FilteredPngStack";
import {
    MobilePreviewArrowButton,
    MobilePreviewArrowImage,
    MobilePreviewDot,
    MobilePreviewHeading
} from "src/components";

const FlexContainer = styled.div`
    display: flex;
    flex-direction: ${p => p.direction || "row"};
    align-items: center;
`;

const WidthContainer = styled.div`
    box-sizing: ${p => p.boxSizing};
    display: flex;
    height: ${p => p.height || "100%"};
    width: ${p => p.width};
    align-self: center;
    align-items: center;
    justify-content: center;
    flex-direction: ${p => p.direction};
    margin-top: ${p => p.marginTop};
    min-height: ${p => p.minHeight};
    padding: ${p => p.padding};
    position: ${p => p.position};
`;

class ImageSlider extends Component {
    /**
     * @param {int} currentScreen
     * @param {int[]} screenIds
     * @return {Dot[]}
     */
    renderDotsForSlides(currentScreen, screenIds) {
        return screenIds.map((id, index) =>
            <MobilePreviewDot key={index} isHighlighted={id === currentScreen} />
        );
    }

    render() {
        const { currentScreen, leftScreen, rightScreen, currentForm, imageWidth,
            screenIds, colourPalette, assetLogoUrl, assetIconUrl } = this.props;
        const dots = this.renderDotsForSlides(currentScreen, screenIds);

        return (
            <FlexContainer direction="column">

                <FlexContainer>
                    
                    <WidthContainer padding="10px">
                        <MobilePreviewArrowButton type="button" onClick={leftScreen} aria-label="Previous preview screen">
                            <MobilePreviewArrowImage src={LeftArrow} alt="" aria-hidden="true" />
                        </MobilePreviewArrowButton>
                    </WidthContainer>
                    
                    <div>
                        <MobilePreviewHeading size="1.25em">
                            {ScreenSwitch(currentScreen)}
                        </MobilePreviewHeading>

                        {/* Images container */}
                        <WidthContainer width={ imageWidth || "100%" } direction="column">
                            <WidthContainer width={"252px"} height={"512px"} direction="column" padding="40px"
                                boxSizing="border-box" position="relative" minHeight="500px">

                                <FilteredPngStack
                                    margin={"auto"}
                                    currentForm={currentForm}
                                    colourPalette={colourPalette}
                                    currentScreen={currentScreen}
                                    logoUrl={assetLogoUrl}
                                    iconUrl={assetIconUrl}
                                />
                            </WidthContainer>

                            {/* Displayed dots below images*/}
                            
                            <WidthContainer width="100%" height="auto" boxSizing="border-box" padding="8px">
                                <WidthContainer direction="row" width="100%">
                                    {dots}
                                </WidthContainer>
                            </WidthContainer>
                            
                        </WidthContainer>
                    </div>

                    <WidthContainer padding="10px">
                        <MobilePreviewArrowButton type="button" onClick={rightScreen} aria-label="Next preview screen">
                            <MobilePreviewArrowImage src={RightArrow} alt="" aria-hidden="true" />
                        </MobilePreviewArrowButton>
                    </WidthContainer>
                </FlexContainer>
            </FlexContainer>
        );
    }
}

export default ImageSlider;
